export class SETTING {

    /**
     * Tiếng việt
     */
    static readonly royal_title_frame_studio_viet_nam = 'royal_title_frame_studio_viet_nam';

    /**
     * Tiếng anh
     */
    static readonly royal_meta_tag_trang_chu_english = 'royal_meta_tag_trang_chu_english';
    static readonly royal_title_trang_chu_english = 'royal_title_trang_chu_english';
    static readonly royal_title_tong_quan_english = 'royal_title_tong_quan_english';
    static readonly royal_title_chuong_trinh_hoc_english = 'royal_title_chuong_trinh_hoc_english';
    static readonly royal_title_chuong_trinh_hoc_mam_non_english = 'royal_title_chuong_trinh_hoc_mam_non_english';
    static readonly royal_title_chuong_trinh_hoc_tieu_hoc_english = 'royal_title_chuong_trinh_hoc_tieu_hoc_english';
    static readonly royal_title_chuong_trinh_hoc_trung_hoc_english = 'royal_title_chuong_trinh_hoc_trung_hoc_english';
    static readonly royal_title_moi_truong_hoc_tap_english = 'royal_title_moi_truong_hoc_tap_english';
    static readonly royal_title_tuyen_sinh_english = 'royal_title_tuyen_sinh_english';
    static readonly royal_title_tuyen_sinh_bieu_phi_english = 'royal_title_tuyen_sinh_bieu_phi_english';
    static readonly royal_title_hinh_anh_english = 'royal_title_hinh_anh_english';
}
